/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolConstructionIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-construction"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M17.93 20.45L13.43 15.97L16 13.4L20.5 17.9Q21.02 18.43 21.02 19.18Q21.02 19.93 20.5 20.45Q19.98 20.98 19.21 20.98Q18.45 20.98 17.93 20.45ZM3.52 20.43Q3.52 20.43 3.25 20.15Q2.98 19.88 2.98 19.13Q2.98 18.38 3.52 17.82L9.4 11.95L8.05 10.6L8.05 10.6Q7.7 10.95 7.25 10.95Q6.8 10.95 6.45 10.6L5.83 9.97L5.83 12.07Q5.83 12.53 5.42 12.7Q5.03 12.88 4.7 12.55L2.17 10.03Q1.85 9.7 2.02 9.3Q2.2 8.9 2.65 8.9L4.75 8.9L4.25 8.4Q3.85 8 3.85 7.47Q3.85 6.95 4.25 6.55L7.5 3.3Q8.07 2.73 8.72 2.46Q9.38 2.2 10.05 2.2Q10.6 2.2 11.1 2.34Q11.6 2.48 12.03 2.83Q12.25 3.02 12.26 3.33Q12.28 3.63 12.07 3.83L10.05 5.85L10.63 6.42Q10.97 6.78 10.97 7.22Q10.97 7.67 10.63 8.03L10.63 8.03L11.97 9.38L14.25 7.1Q14.18 6.85 14.14 6.56Q14.1 6.28 14.1 6Q14.1 4.38 15.19 3.29Q16.27 2.2 17.9 2.2Q18.13 2.2 18.35 2.21Q18.57 2.23 18.8 2.27Q19.07 2.38 19.14 2.66Q19.2 2.95 19 3.15L17.38 4.78Q17.18 4.97 17.18 5.25Q17.18 5.53 17.38 5.72L18.23 6.58Q18.43 6.78 18.7 6.78Q18.98 6.78 19.18 6.58L20.85 4.9Q21.05 4.7 21.34 4.76Q21.63 4.83 21.73 5.1Q21.77 5.33 21.79 5.55Q21.8 5.78 21.8 6Q21.8 7.63 20.71 8.71Q19.63 9.8 18 9.8Q17.73 9.8 17.45 9.75Q17.18 9.7 16.9 9.65L6.13 20.43Q5.58 20.98 4.83 20.98Q4.08 20.98 3.52 20.43Z" fill={color} />
    </svg>
  );
}
